export default __webpack_public_path__ + "static/media/Q4_1.1deb10cc.jpg";